import styled from 'styled-components';

export const BlockZeroCoins = styled.div`
  text-align: center;
  & > .hefesto-icon svg {
    width: 6.25rem;
    height: 6.25rem;
  }
`;
